import React from "react";
import { Link } from "react-router-dom";
const vehicles = [
  {
    id: 1,
    name: "Swift Dzire",
    image: "/images/fleet/Swift-Dzire.png",
    seater: "4+1",
    luggage: "2 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Popular sedan perfect for daily travel and airport transfers.",
  },
  {
    id: 2,
    name: "Maruti Ertiga",
    image: "/images/fleet/Maruti-Ertiga.png",
    seater: "6+1",
    luggage: "4 Bags",
    fuel: "Petrol / CNG",
    ac: "AC",
    desc: "Spacious MPV ideal for family trips and group travel.",
  },
  {
    id: 3,
    name: "Kia Carens",
    image: "/images/fleet/Kia-Carens.png",
    seater: "6+1",
    luggage: "4 Bags",
    fuel: "Petrol / Diesel",
    ac: "AC",
    desc: "Premium MPV with modern features and comfortable seating.",
  },
  {
    id: 4,
    name: "Innova Cab",
    image: "/images/fleet/Innova-Cab.png",
    seater: "7+1",
    luggage: "5 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Comfortable MPV ideal for airport transfers and outstation travel.",
  },
  {
    id: 5,
    name: "Innova Crysta",
    image: "/images/fleet/Innova-Crysta.png",
    seater: "7+1",
    luggage: "5 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Luxury MPV perfect for corporate travel and family trips.",
  },
    {
      id: 3,
  name: "Toyota Rumion",
  image: "/images/fleet/Toyota-Rumion.png",
  seater: "6+1",
  luggage: "4 Bags",
  fuel: "Petrol",
  ac: "AC",
  desc: "Comfortable MPV suitable for family trips, airport transfers and outstation travel.",
},
  {
    id: 6,
    name: "Tempo Traveller",
    image: "/images/fleet/Tempo-Traveller.png",
    seater: "13",
    luggage: "10 Bags",
    fuel: "Diesel",
    ac: "AC / Non AC",
    desc: "Best vehicle for group tours, weddings and family trips.",
  },
  {
    id: 7,
    name: "Urbania Bus",
    image: "/images/fleet/Urbania-Bus.png",
    seater: "17",
    luggage: "12 Bags",
    fuel: "Diesel",
    ac: "AC",
    desc: "Luxury traveller with premium interiors and spacious seating.",
  },
  {
    id: 8,
    name: "Mini Bus",
    image: "/images/fleet/Mini-Bus.png",
    seater: "20-32",
    luggage: "20 Bags",
    fuel: "Diesel",
    ac: "AC / Non AC",
    desc: "Ideal for corporate transport, weddings and group tours.",
  },
];

const OurFleets = () => {
  return (
    <>
    
 <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Our Fleets </h1>
          </div>
        </div>
      </div>



    
    <div className="section-full py-3 fleet-wrap">
      <div className="container">

        {/* Title */}
      

        {/* Grid */}
        {/* <div className="row">

          {vehicles.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-4 col-sm-6 mb-4">

              <div className="fleet-card">

                <div className="fleet-img">
                  <img src={item.image} alt={item.name} />
                </div>

           
<div className="fleet-content">
  <h4>{item.name}</h4>

  <div className="fleet-specs">
    <span>👥 {item.seater}</span>
    <span>🧳 {item.luggage}</span>
  </div>

  <div className="fleet-specs">
    <span>❄️ {item.ac}</span>
    <span>⛽ {item.fuel}</span>
  </div>

  <p>{item.desc}</p>

</div>



              </div>

            </div>
          ))}

        </div> */}


<div className="row">

  {vehicles.map((item) => (
    <div key={item.id} className="col-12 mb-4">

      <div className="fleet-card">

        <div className="fleet-img  ">
          <img src={item.image} alt={item.name} />
        </div>

        <div className="fleet-content">

          <h3 className="text-white">{item.name}</h3>

          <div className="fleet-specs">

            <div className="spec">
              👥 <strong>{item.seater}</strong>
              <small>Seater</small>
            </div>

            <div className="spec">
              🧳 <strong>{item.luggage}</strong>
              <small>Luggage</small>
            </div>

            <div className="spec">
              ❄️ <strong>{item.ac}</strong>
              <small>AC</small>
            </div>

            <div className="spec">
              ⛽ <strong>{item.fuel}</strong>
              <small>Fuel</small>
            </div>

          </div>

          <p className="text-white pb-5">{item.desc}</p>

      <Link to="/booking" className="fleet-btn">
  Book Now
</Link>

        </div>

      </div>

    </div>
  ))}

</div>
      </div>

      {/* Styling */}
      <style jsx>{`
        .fleet-wrap {
          background: linear-gradient(135deg, #fff7ed, #fef3e2);
        }

        .fleet-card {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid #f3d6b3;
          box-shadow: 0 6px 18px rgba(90, 45, 12, 0.12);
          transition: 0.3s;
          height: 100%;
        }

        .fleet-card:hover {
          transform: translateY(-6px);
        }

        .fleet-img img {
          width: 100%;
        //   height: 200px;
          object-fit: cover;
        }

        .fleet-content {
          padding: 15px;
          text-align: center;
          
        }

        .fleet-content h4 {
          color: #1A4160;
          margin-bottom: 8px;
        }

        .fleet-content p {
          color: #192555;
          font-size: 14px;
          margin: 0;
        }
      `}</style>
    </div>
    </>
  );
};

export default OurFleets;